import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';

import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';
import { querySelector } from '../../../utils';

export const GetUserMonthBonus = gql`
  query GetUserMonthBonusQuery($userBonusMonthId: Int!) {
    user_month_bonus(id: $userBonusMonthId) {
      id
      user_ticket_bonuses {
        edges {
          node {
            paidPerDiems: paid_per_diems
            userTicketBonusForm: user_ticket_bonus_form {
              bonusAmount: bonus_amount
              id
              bonusPercentage: bonus_percentage
              bonusRate: bonus_rate
              notes
              userBonusEligible: user_bonus_eligible
              ticket {
                id
                crewSize: crew_size
                bonusType: bonus_type
                date {
                  iso8601
                  display
                }
                ticketNumber: ticket_number {
                  id
                  number
                }
                billingRevenue: billing_revenue
                billingHours: billing_hours
                state
                job {
                  id
                }     
              }          
            }
          }
        }
      }
    }
  }
`;

const marshallData = ({ data, ownProps }) => {
  const allUserTicketBonuses = querySelector(data, '$.user_month_bonus.user_ticket_bonuses.edges[*].node', []);

  return {
    ...ownProps,
    data,
    allUserTicketBonuses,
  };
};

const queryGetUserMonthBonusData = graphql(GetUserMonthBonus, {
  props: marshallData,
});

export const queryGetUserMonthBonusGQL = compose(
  queryGetUserMonthBonusData,
  queryMetaHandler,
  omitProps(['data']),
);
